import ComboSlotOption from './combo-slot-option';

export default ComboSlotOption;
